module.exports = __webpack_public_path__ + "img/iPad.3521b0fb.jpg";